/** @jsx jsx */
import { jsx, css } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React, { useMemo, useRef } from 'react';
import { NodeLinkChart } from './chart';
import { SubtitleCountRenderer } from 'components/virtualTooltip/renderers';
import { useChart } from 'hooks/useChart';

/**
 * Renders a simple node-link diagram.
 *
 * Expects: {
 *   nodes: [],
 *   links: [],
 * }
 * @param {function} getColor
 * @param {object} dimensions
 * @param {object} data
 * @param widgetConfiguration
 */
export const NodeLink = ({ getColor, dimensions, data, widgetConfiguration }) => {
	const svgRef = useRef();
	const containerRef = useRef();

	const options = useMemo(() => {
		return { colorScale: getColor };
	}, [getColor]);

	const { TooltipElement } = useChart({
		svgRef,
		containerRef,
		data,
		dimensions,
		options,
		Chart: NodeLinkChart,
		renderer: SubtitleCountRenderer,
		supportSelection: widgetConfiguration?.supportSelection || false,
	});

	return (
		<React.Fragment>
			{TooltipElement}
			<svg css={graphCss} width={dimensions.width} height={dimensions.height} ref={svgRef} cy-test="node-link-data">
				<g ref={containerRef} />
			</svg>
		</React.Fragment>
	);
};

const graphCss = css`
	.label {
		display: none;
		pointer-events: none;

		&.visible {
			display: initial;
		}

		&.nonneighbor {
			display: none;
		}
	}
`;
